"use client";

import React from "react";
import { twMerge } from "tailwind-merge";

import { MainTitleProps } from "@/TS/Interfaces/global_interfaces";

function MainTitle({
  title,
  className,
  parentClassName,
  jsxButton: _jsxButton,
  children,
  ...rest
}: MainTitleProps) {
  return (
    <div
      className={twMerge(
        `flex mb-2 md:mb-8 w-full justify-start lg:justify-between items-center flex-col lg:flex-row gap-4 lg:gap-0  ${parentClassName}`,
      )}
      {...rest}
    >
      <h1 className={twMerge(`font-bold text-pretty lg:text-3xl ${className}`)}>
        {title}
      </h1>
      <div className="block">{children}</div>
    </div>
  );
}

export default MainTitle;
